var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.showLoader)?_c('a',{attrs:{"href":"/logout"},on:{"click":function($event){$event.preventDefault();return _vm.logout($event)}}},[_vm._v("\n        Logout\n    ")]):_c('div',{staticClass:"loading"},[_c('loading-indicator')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }